export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (!serializedState) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.error("Failure in loadState", err);
    return undefined;
  }
};

export const saveState = (state: any) => {
  try {
    const serializedState = JSON.stringify(state);
    // console.log("[localStorage] state length: ", serializedState.length);
    // const byteSize = new Blob([serializedState]).size;

    // console.log("[localStorage] state size: ", byteSize);

    localStorage.setItem("state", serializedState);
  } catch (err) {
    console.error("Failure in saveState", err);
    return undefined;
  }
};

export const deleteState = () => {
  localStorage.removeItem("state");
};

const EXTENSION_LOGOUT_TRIGGERED = "EXTENSION_LOGOUT_TRIGGERED";

export const setExtensionLogoutFlag = () => {
  sessionStorage.setItem(EXTENSION_LOGOUT_TRIGGERED, "true");
};

export const clearExtensionLogoutFlag = () => {
  sessionStorage.removeItem(EXTENSION_LOGOUT_TRIGGERED);
};

export const getExtensionLogoutFlag = (): boolean => {
  const value = sessionStorage.getItem("EXTENSION_LOGOUT_TRIGGERED");
  return value ? value === "true" : false;
};
